import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 8.667a.667.667 0 0 0-.667.666v2a.667.667 0 0 0 1.334 0v-2A.667.667 0 0 0 8 8.667M11.333 6V4.667a3.333 3.333 0 0 0-6.666 0V6a2 2 0 0 0-2 2v4.667a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M6 4.667a2 2 0 1 1 4 0V6H6zm6 8a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V8a.667.667 0 0 1 .667-.667h6.666A.667.667 0 0 1 12 8z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })